import Vue from "vue";
import LiquorTree from "liquor-tree";

Vue.use(LiquorTree);
